import { FormattedMessage } from 'react-intl';
import { InvoiceStatus } from 'store/subscription/types';

const statusStyleMap: Record<InvoiceStatus, string> = {
  draft: 'bg-gray-50 text-gray-600 ring-gray-500/10',
  open: 'bg-yellow-50 text-yellow-800 ring-yellow-600/20',
  paid: 'bg-green-50 text-green-700 ring-green-600/20',
  void: 'bg-indigo-50 text-indigo-700 ring-indigo-700/10',
  uncollectible: 'bg-pink-50 text-pink-700 ring-pink-700/10',
};

export const InvoiceStatusBadge = ({ status }: { status: InvoiceStatus }) => {
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${statusStyleMap[status]}`}
    >
      <FormattedMessage id={status} />
    </span>
  );
};
